module.exports = __webpack_public_path__ + "static/img/nuestras-plantas.9c65655.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nuestras-plantas/nuestras-plantas.jpg
// module id = RJFY
// module chunks = 0